import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ProjectsPage from '../pages/ProjectsPage';
import BlogPage from '../pages/BlogPage';
import React from 'react';

const routes = [
  {
    id: 1,
    path: '/',
    component: HomePage,
  },
  {
    id: 2,
    path: '/projects',
    component: ProjectsPage,
  },
  {
    id: 3,
    path: '/blog',
    component: BlogPage,
  },
];

const App = () => (
  <Router>
    <div className="main-container">
      <div className="body-container">
        <div className="main-nav">
          <div className="logo-div">
            <div className="top-grid">
              <div className="grid-item grid-1"></div>
              <div className="grid-item grid-2"></div>
            </div>
            <div className="down-grid">
              <div className="grid-item grid-3"></div>
              <div className="grid-item grid-4"></div>
              <div className="grid-item grid-5"></div>
            </div>
          </div>
          <div className="social-contact">
            <div className="social">
              <a
                className="contact"
                target="_blank"
                href="https://www.linkedin.com/in/dev-salley/"
                rel="noopener noreferrer"
              >
                <i className="fa fa-linkedin-square" aria-hidden="true"></i>
              </a>
              <a
                className="contact"
                href="http://github.com/juxsalley/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-github" aria-hidden="true"></i>
              </a>
              <a
                className="contact"
                href="https://twitter.com/__salley"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </a>
            </div>
            <a
              className="contact"
              href="mailto:codesalley@gmail.com?subject=Hello Salley"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Me{' '}
            </a>
          </div>
        </div>
        <Switch>
          {routes.map((ele) => (
            <Route
              path={ele.path}
              exact
              component={ele.component}
              key={ele.id}
            />
          ))}
        </Switch>
      </div>
      <div className="nav-container">
        <NavLink to="/" activeClassName="nav-active" exact className="nav-item">
          PORTFOLIO
        </NavLink>
        <NavLink
          activeClassName="nav-active"
          to="/projects"
          className="nav-item"
        >
          PROJECTS
        </NavLink>

      </div>
    </div>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/componets/App.js